import { ScrollTrigger } from "gsap/ScrollTrigger";
import initGsapScrollState from "../triggers/gsapScrollState";
import initGsapAos from "../triggers/gsapAos";
import initGsapUnveil from "../triggers/gsapUnveil";
import initGsapSticker from "../triggers/gsapSticker";
import initGsapOdometer from "../triggers/gsapOdometer";
import initHorizontalScroll from "../triggers/gsapHorizontalScroll";
import gsapVerticalStickyContent from "../triggers/gsapVerticalStickyContent";

export default function initGsapTriggers() {
    initGsapScrollState();
    initGsapAos();
    initGsapSticker();
    initGsapOdometer();
    initHorizontalScroll();
    initGsapUnveil();
    gsapVerticalStickyContent();
    
    

    if (MNK) {
    }

    // Force refresh after everything is loaded to ensure correct calculations
    const refreshTriggers = () => {
        ScrollTrigger.refresh();
    };

    requestAnimationFrame(refreshTriggers);
    
    // If the page loads with a scroll position (reload mid-page), 
    // the browser restores scroll position which can throw off calculations.
    // We force refreshes after a delay to ensure layout is settled.
    if (window.scrollY > 0 || document.documentElement.scrollTop > 0) {
        setTimeout(refreshTriggers, 500);
        setTimeout(refreshTriggers, 1000);
    }

    // Handle Back/Forward Cache (BFCache)
    window.addEventListener("pageshow", (event) => {
        // If the page is being restored from the bfcache
        if (event.persisted) {
            // Force a complete refresh of ScrollTrigger
            setTimeout(() => {
                ScrollTrigger.refresh();
            }, 100);
        }
    });

    // Refresh ScrollTrigger when images are loaded (if they affect layout)
    // This helps when images load after the initial JS execution
    const images = document.querySelectorAll('img');
    let loadedImages = 0;
    
    if (images.length > 0) {
        images.forEach(img => {
            if (img.complete) {
                loadedImages++;
            } else {
                img.addEventListener('load', () => {
                    loadedImages++;
                    if (loadedImages === images.length) {
                        ScrollTrigger.refresh();
                    }
                });
            }
        });
    }

    // Refresh when fonts are loaded
    document.fonts.ready.then(() => {
        ScrollTrigger.refresh();
    });
}
